import React from 'react';
import "./ProductCard.css";
import { useLocation, useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
  console.log(product)
  const { title, brand, imageUrl, price, discountedPrice, color, discountPersent } = product;
  const navigate = useNavigate();


  const handleNavigate = () => {
    navigate(`/product/${product?._id}`)
  }

  return (
    //------------------------------------Similar product cart----------------------------------
    <div onClick={handleNavigate} className='flex-col flex justify-content-between productCard w-[9.7rem] md:w-[17vw] h-[55vh] border md:m-3 m-1 transition-all cursor-pointer '>
      <div className="flex h-[60%] w-full flex-col items-center overflow-hidden">
  <img
    className="h-[400px] w-[400px] object-contain"
    src={imageUrl[0]||imageUrl }
    alt="product image"
    loading="lazy"
  />
</div>
      <div className='textPart h-50% bg-white p-3'>
        <div>
          <p className='font-bold opacity-60'>{brand}</p>
          <p className=''>{title}</p>

          <p className='font-semibold opacity-50'>{color}</p>
        </div>

        <div className='flex space-x-2 items-center'>
          <p className='font-semibold'>₹{discountedPrice}</p>
          <p className='opacity-50 line-through'>₹{price}</p>
          <p className='text-green-600 font-semibold'>{discountPersent||100-Math.round(discountedPrice*100/price)}% off</p>
        </div>
      </div>
    </div>

  
  );
};

export default ProductCard;
